import { NetworkManager } from "@/infrastructure/services/network";
import { UserRepository } from "@/infrastructure/repositories/user";
import { AuthRepository } from "@/infrastructure/repositories/auth";
import { GetUserAccessTokenUseCase } from "@/core/usecases/user/GetUserAccessToken.useCase";
import { GetWorkSpaceAccessTokenUseCase, GetWorkSpaceRefreshTokenUseCase } from "@/core/usecases/workspace";
import { WorkSpaceRepository } from "@/infrastructure/repositories/workspace";
import { GetUserDetailsUseCase } from "@/core/usecases/auth";
import { IHttpClientModel } from "@ir/core/http";

export class PrivateUserDetailsHttp extends NetworkManager {
  constructor(_networkConfig?: Omit<IHttpClientModel, "baseURL">) {
    super(_networkConfig);
    this.handlePrivateRequest();
  }

  protected handlePrivateRequest(isBrandTokenRequired: boolean = true) {
    this.httpService.interceptors.request.use(
      async config => {
        const userAccessToken = await this.getUserAccessToken();
        const workSpaceAccessToken = await this.getWorkSpaceAccessToken();
        const workSpaceRefreshToken = await this.getWorkSpaceRefreshToken();

        config.headers = {
          ...config.headers,
          Authorization: `Bearer ${userAccessToken}`,
          ["X-Brand-Authorization"]: isBrandTokenRequired ? `Bearer ${workSpaceAccessToken}` : undefined,
          ["X-Brand-Refresh-Token"]: isBrandTokenRequired ? `Bearer ${workSpaceRefreshToken}` : undefined,
        };
        return config;
      },
      error => {
        return Promise.reject(error instanceof Error ? error : new Error(String(error)));
      }
    );
  }

  protected async getUserAccessToken() {
    const userAccessToken = await new GetUserAccessTokenUseCase(new UserRepository(new AuthRepository())).execute();
    return userAccessToken ?? null;
  }

  protected async getWorkSpaceAccessToken() {
    const workSpaceAccessToken = await new GetWorkSpaceAccessTokenUseCase(new WorkSpaceRepository(new AuthRepository())).execute();
    return workSpaceAccessToken ?? null;
  }

  protected async getWorkSpaceRefreshToken() {
    const workSpaceRefreshToken = await new GetWorkSpaceRefreshTokenUseCase(new WorkSpaceRepository(new AuthRepository())).execute();
    return workSpaceRefreshToken ?? null;
  }

  protected async getUserDetails() {
    const userDetails = await new GetUserDetailsUseCase(new AuthRepository()).execute();
    return userDetails ?? null;
  }
}
